import React from 'react'
import styles from './index.less'

function index() {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <span className={styles.text}>方案架构</span>
                <span className={styles.line}></span>
            </div>
            <div className={styles.content}>
                <img src={require('assets/images/home/001.png')} alt="" />
                <img src={require('assets/images/home/002.png')} alt="" />
                <img src={require('assets/images/home/003.png')} alt="" />
                <img src={require('assets/images/home/004.png')} alt="" />

            </div>
            <div className={styles.bg}>
                <img src={require('assets/images/home/left.png')} alt="" />
                <img src={require('assets/images/home/right.png')} alt="" />
            </div>
        </div>
    )
}

export default index